// extracted by mini-css-extract-plugin
export default {"mobile":"videoPlayer_mobile__CIVeX","laptop":"videoPlayer_laptop__J7myK"};